module.exports = __webpack_public_path__ + "static/img/Queen of Pentacles.fdd5689.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Queen of Pentacles.jpg
// module id = 1292
// module chunks = 0